/**
 *
 * Take a date and a trailing slash if need
 *
 * @example
 * // return '15/'
 * autocompleteDate('15')
 * @example
 * // return '15/01/'
 * autocompleteDate('1501')
 * @example
 * // return '15/01/94'
 * autocompleteDate('150194')
 * @param {string} date
 * @returns string
 *
 */
const autocompleteDate = (date) => {
  if (!date) {
    return null
  }
  if (date.length > 8) {
    return date.slice(0, 8 - date.length)
  }
  if (date.length >= 4) {
    return `${date.substring(0, 2)}/${date.substring(2, 4)}/${date.substring(4, date.length)}`
  }
  if (date.length >= 2) {
    return `${date.substring(0, 2)}/${date.substring(2, date.length)}`
  }

  return date
}

/**
 *
 * Take a date in the format jj/mm/aaaa
 * and return it to the vuetify format yyyy-mm-dd
 *
 * @example
 * // return ''
 * parseDate('22/')
 * parseDate('15/01')
 * parseDate('')
 * @example
 * // return '1994-01-15'
 * parseDate('15/01/1994')
 * @param {string} date
 * @returns string
 *
 */
const parseDate = (date) => {
  if (!date) {
    return null
  }
  // TODO (JBO) find a way to parse other date format
  const [day, month, year,] = date.split('/')

  if (!day || !month || !year) {
    return ''
  }

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export { autocompleteDate, parseDate }
